// import React, { useState } from 'react';
// import { useHistory } from 'react-router-dom';
import { signupOwner } from '../../services/authService';

import React, { useState } from 'react';
// import { ownerSignup } from '../services/authService';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// import Toast from '../components/common/Toast';

import { toast } from 'react-toastify';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 5000,
});

function AdminSignup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  //   const history = useHistory();
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast('Passwords do not match', 'error');
      return;
    }
    try {
      setLoading(true);

      //   const response = await signupOwner(name, email, password);
      const response = await api.post(`/auth/admin/signup`, {
        name,
        email,
        password,
      });
      console.log(response);
      if (response) {
        localStorage.setItem('adminToken', response.data.token);
        // const response = await axios.post('/api/auth/owner-signup', {
        //   name,
        //   email,
        //   password,
        // });
        setSuccess('Account created successfully!');
        setName('');
        setEmail('');
        setPassword('');
        // history.push('/owner-dashboard');
        navigate('/admin/dashboard');
      } else {
        setError('Signup failed. Please try again.');

        toast.error('Signup failed.');
      }
    } catch (error) {
      setError('Signup failed. Please try again.');

      toast.error('Error during signup.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
      <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
        <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
          Owner Signup
        </h2>
        {error && <p className='text-red-500 mb-4'>{error}</p>}
        {success && <p className='text-green-500 mb-4'>{success}</p>}

        <input
          type='text'
          className='w-full p-3 mb-4 border rounded-lg'
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='Enter your name'
        />
        <input
          type='text'
          className='w-full p-3 mb-4 border rounded-lg'
          placeholder='Enter your email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type='password'
          className='w-full p-3 mb-4 border rounded-lg'
          placeholder='Enter your password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type='password'
          value={confirmPassword}
          placeholder='Confirm password'
          className='w-full p-3 mb-4 border rounded-lg'
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button
          className='bg-blue-500 text-white py-2 px-4 rounded-lg'
          onClick={handleSignup}
          disabled={loading}
        >
          {loading ? 'Signing up...' : 'Signup'}
        </button>
      </div>
    </div>
  );
}

export default AdminSignup;

// const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await ownerSignup({ email, password });
//       localStorage.setItem('ownerToken', response.token);
//       Toast.success('Signup successful');
//       navigate('/owner-dashboard');
//     } catch (error) {
//       Toast.error('Signup failed. Please try again.');
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto mt-10">
//       <h1 className="text-3xl font-bold mb-6 text-center">Owner Signup</h1>
//       <form onSubmit={handleSubmit}>
//         <div className="mb-4">
//           <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//           <input
//             type="email"
//             id="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <div className="mb-4">
//           <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
//           <input
//             type="password"
//             id="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             required
//           />
//         </div>
//         <button
//           type="submit"
//           className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
//         >
//           Signup
//         </button>
//       </form>
//     </div>
//   );

// return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
//       <h2 className="text-2xl font-bold mb-4">Owner Signup</h2>
//       <input
//         type="email"
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <input
//         type="password"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         className="mb-2 p-2 border rounded"
//       />
//       <button
//         onClick={handleSignup}
//         className="bg-green-500 text-white px-4 py-2 rounded"
//       >
//         Sign Up
//       </button>
//     </div>
//   );
